import { WSQueryConfig } from "@ws-react-query";

import { useWSQuery } from "../../helpers";
import { QUERY_MONITOR_SETTINGS_ITEM } from "../keys";
import type { insuranceMonitorSettingsApiSpec } from "@wingspanhq/wingspan-api-types";
import { getMonitorSettingsItem } from "../../../services/api/insurance/monitorSettings/getMonitorSettingsItem";

export const useQueryMonitorSettings = (
  monitorSettingsId: string,
  queryConfig?: WSQueryConfig<
    insuranceMonitorSettingsApiSpec.InsuranceCoverageMonitorSettings,
    unknown
  >
) =>
  useWSQuery(
    [QUERY_MONITOR_SETTINGS_ITEM, monitorSettingsId],
    () => getMonitorSettingsItem(monitorSettingsId),
    {
      retry: false,
      refetchOnMount: false,
      ...queryConfig
    }
  );
